import type { SxProps, Theme } from '@mui/material';

export const styles = {
    content: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2.5,
        py: 1,
    } as SxProps<Theme>,
    actions: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 1,
        pt: 1,
    } as SxProps<Theme>,
    sectionLabel: {
        fontSize: '12px',
        color: 'grey.500',
        mb: 0.5,
    } as SxProps<Theme>,
};
